import domReady from '@wordpress/dom-ready';

const TabNav = () => {
	const tabNavs = document.querySelectorAll('.ahha-tab__nav-wrap');

	if (tabNavs) {
		tabNavs.forEach((tabNav) => {
			const tab = tabNav.closest('.ahha-tab');

			if (tab) {
				const tabContent = tab.querySelector('.ahha-tab__content');
				const heading = tabNav.previousElementSibling;

				const tabNavItems = tabNav.querySelectorAll('.ahha-tab__nav-item');
				const tabContentItems = tabContent.querySelectorAll('.ahha-tab__content-item');

				const selectElement = document.createElement('select');
				selectElement.classList.add('ahha-tab__nav-select');
				selectElement.setAttribute('aria-label', 'Select tab');

				tabNavItems.forEach((item, index) => {
					const option = document.createElement('option');
					option.value = index;
					option.textContent = item.textContent;
					selectElement.appendChild(option);
				});

				selectElement.addEventListener('change', (event) => {
					const selectedIndex = event.target.value;

					const activeTabNavItems = tabNav.querySelectorAll('.ahha-tab__nav-item.active');
					activeTabNavItems.forEach((navItem) => {
						navItem.classList.remove('active');
					});

					const activeTabContentItems = tabContent.querySelectorAll(
						'.ahha-tab__content-item.active',
					);
					activeTabContentItems.forEach((contentItem) => {
						contentItem.classList.remove('active');
					});

					const selectedContentItem = tabContentItems[selectedIndex];
					selectedContentItem.classList.add('active');

					const selectedNavItem = tabNavItems[selectedIndex];
					selectedNavItem.classList.add('active');
				});

				heading.appendChild(selectElement);
			}
		});
	}
};

domReady(() => {
	TabNav();
});
